import DetectorInterface from "../DetectorInterface";
import Detector from '../Detector';

export default class ZipCode extends Detector implements DetectorInterface {

    public match(value: string): boolean {
        return /^[0-9]{5}$/ig.test(value);
    }
}
